import React, { useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { useNavigate } from "react-router-dom";
import { API_URL } from "..";
import Swal from "sweetalert2";

const CustomerTable = ({ data }) => {
  const history = useNavigate();

  const handleDelete = async (id) => {
    const apiCall = await fetch(`${API_URL}/api/customer/delete-single/${id}/false`, {
      method: "DELETE",
    });
    const response = await apiCall.json();
    if (apiCall.status === 200) {
      window.location.reload();
    }
    if (response.message === "Error delete customer") {
      const result = await Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "This customer has jobs which are linked. Are you sure you want to delete this customer? This also removes the jobs data too.",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: "Not Now",
        confirmButtonText: "I Agree",
      });

      if (result.isConfirmed) {
        try {
          const response = await fetch(`${API_URL}/api/customer/delete-single/${id}/true`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
          });
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          const data = await response.json();
          if (response.status === 200) {
            window.location.reload();
          } else {
            throw new Error(data.message || "Failed to delete customer");
          }
        } catch (error) {
          console.error("Error deleting customer:", error.message);
        }
      }
    }
  };

  useEffect(() => {
    const table = $("#dataTable").DataTable({
      data: data,
      responsive: true,
      pageLength: 10,
      order: [[0, "desc"]],
      columns: [
        { data: "id" ,render :(data, type, row)=>{
          return `<span style="cursor:pointer;text-decoration:underline" class="dropdown-item view-btn" data-id="${row.id}">${data}</span>`;;
        } },

        { data: "name" ,render: function (data, type, row) {
          if (!data) return "<span>N/A</span>";
      
          const short = data.length > 10 ? data.slice(0, 50) + "…" : data;
          return `
            <span class="client-name-cell" title="${data}">
              ${short}
            </span>
          `;
        }},
        { data: "phone" },
        { data: "email" },
        {
          data: null,
          render: function (data, type, row) {
            return `
              <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View </a></li>
                  <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit </a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete </a></li>
                </ul>
              </div>
            `;
          },
          title: "Actions",
          orderable: false,
        },
      ],
    });

    $("#dataTable tbody").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      history(`/customers/edit/${id}`);
    });

    $("#dataTable tbody").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      history(`/customers/view/${id}`);
    });

    $("#dataTable tbody").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      handleDelete(id);
    });

    return () => {
      table.destroy(true);
    };
  }, [data, history]);

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="card-title mb-0 col-md-6">List of Customers</h5>
          <div className="col-md-6 text-end"></div>
        </div>
      </div>
      <div className="card-body">
        <table
          className="table bordered-table mb-0"
          id="dataTable"
          data-page-length={10}
        >
          <thead>
            <tr>
              <th scope="col">
                <div className="form-check style-check d-flex align-items-center">
                  <label className="form-check-label">S.L</label>
                </div>
              </th>
              <th scope="col">Name</th>
              <th scope="col">Phone</th>
              <th scope="col">Email</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerTable;